import yup from 'yup';
import moment from 'moment';

const initialForm = {
  airline: '',
  flightNo: '',
  airportOrigin: '',
  airportDestination: '',
  departureDate: moment(new Date()),
  arrivalDate: moment(new Date()),
  departureTime: '',
  arrivalTime: ''
};

const ERROR_REQUIRED = 'This field is required';
const ERROR_NUMBER = 'Must be a number';

export const formikConfig = {
  enableReinitialize: true,
  mapPropsToValues: props => ({ ...initialForm }),
  validationSchema: () => {
    return yup.object().shape({
      airline: yup.string().required(ERROR_REQUIRED),
      flightNo: yup
        .number()
        .typeError(ERROR_NUMBER)
        .required(ERROR_REQUIRED)
        .integer(),
      airportOrigin: yup.string().required(ERROR_REQUIRED),
      airportDestination: yup.string().required(ERROR_REQUIRED),
      departureDate: yup.mixed().required(ERROR_REQUIRED),
      arrivalDate: yup.mixed().required(ERROR_REQUIRED),
      departureTime: yup.string().required(ERROR_REQUIRED),
      arrivalTime: yup.string().required(ERROR_REQUIRED)
    });
  },
  handleSubmit: (values, { props, setSubmitting, setErrors, setStatus }) => {
    const {
      departureDate,
      departureTime,
      arrivalDate,
      arrivalTime,
      airline,
      flightNo,
      airportOrigin,
      airportDestination
    } = values;
    const localDepartureDate = moment(departureDate)
      .hours(departureTime.slice(0, 2))
      .minutes(departureTime.slice(-2))
      .format('YYYY-MM-DDTHH:mm:ss');
    const localArrivalDate = moment(arrivalDate)
      .hours(arrivalTime.slice(0, 2))
      .minutes(arrivalTime.slice(-2))
      .format('YYYY-MM-DDTHH:mm:ss');
    const flight = {
      airlineCode: airline,
      number: parseInt(flightNo, 10),
      airportOriginCode: airportOrigin.slice(-4),
      airportDestinationCode: airportDestination.slice(-4),
      localDeparture: localDepartureDate,
      localArrival: localArrivalDate
    };
    setSubmitting(true);
    props
      .AttachFlight({
        variables: {
          input: {
            flight,
            flightsPassengerTicket: {
              passengerTicketId: props.passengerTicketId
            }
          }
        }
      })
      .then(({ data }) => {
        setStatus({ refresh: true });
        props.onFlightCreated();
      })
      .catch(error => {
        setErrors({ serverError: error });
        setSubmitting(false);
      });
  }
};



// WEBPACK FOOTER //
// ./src/component/AddFlight/formikConfig.js